import React from "react";
import Modal from "components/Modal";
import EPDOverview from "features/EPDSearchModal/features/EPDOverview";

interface EPDOverviewPopupProps {
  open: boolean;
  close: () => void;
  epdID: string | undefined;
}

const EPDOverviewPopup = (props: EPDOverviewPopupProps) => {
  return (
    <Modal
      isOpen={props.open}
      setIsOpen={props.close}
      title="EPD Overview"
      closeButton
      containerClassName="min-w-[500px] md:min-w-[700px]"
    >
      <EPDOverview epdID={props?.epdID} close={props.close} />
    </Modal>
  );
};

export default EPDOverviewPopup;
